// Videos comprables — versión FunFungi / Shrine (sections/ff-videos-comprables.liquid)
// Adaptada de la sección del tema Sumetis (Dawn). Diferencia principal: Shrine no trae product-form,
// así que «Agregar» usa /cart/add.js y abre el carrito lateral con cart-drawer.renderContents
// (mismo conector que el quiz). Sin promos en JS: precio de lista; Kaching y Shopify hacen el resto.
// - Carga cada video solo cuando se acerca a la pantalla y lo reproduce sin sonido mientras se ve.
// - Botón de sonido por video (al activar uno, se silencian los demás).
// - Flechas del carrusel en escritorio (se ocultan cuando no hay más para mover).
// - Vista grande (<dialog>) con sonido, flechas, teclado y deslizar; producto con botón de compra.
// - Selector de variante pegado al botón: actualiza precio y nombre de la variante.
if (!customElements.get('ff-videos-comprables')) {
  customElements.define(
    'ff-videos-comprables',
    class FFVideosComprables extends HTMLElement {
      connectedCallback() {
        this.pista = this.querySelector('.vc__pista');
        this.items = [...this.querySelectorAll('.vc__item')];
        this.modal = this.querySelector('.vc-modal');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const ahorro = navigator.connection && navigator.connection.saveData;
        this.auto = this.dataset.autoplay === 'true' && !reduce && !ahorro;

        this.observarVideos();
        this.prepararFlechas();
        this.prepararVariantes(this);

        this.addEventListener('click', (e) => {
          const sonido = e.target.closest('.vc__sonido');
          if (sonido) return this.alternarSonido(sonido);
          const abrir = e.target.closest('[data-abrir]');
          if (abrir && this.modal) return this.abrir(Number(abrir.dataset.abrir));
        });
        // Formularios del carrusel y de la vista grande (la vista está dentro de este elemento)
        this.addEventListener('submit', (e) => {
          const form = e.target.closest('.vc-form__form');
          if (!form) return;
          e.preventDefault();
          this.agregar(form);
        });

        if (this.modal) this.prepararModal();

        // Editor de temas: al elegir un video en el panel, el carrusel se mueve hasta él
        if (window.Shopify && Shopify.designMode) {
          this.alElegir = (e) => {
            const item = e.target.closest && e.target.closest('.vc__item');
            if (!item || !this.contains(item)) return;
            this.pista.scrollTo({ left: item.offsetLeft - this.pista.offsetLeft - 16, behavior: 'smooth' });
          };
          document.addEventListener('shopify:block:select', this.alElegir);
        }
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.ioCarga) this.ioCarga.disconnect();
        if (this.ioPoster) this.ioPoster.disconnect();
        if (this.alRedimensionar) window.removeEventListener('resize', this.alRedimensionar);
        if (this.alElegir) document.removeEventListener('shopify:block:select', this.alElegir);
        this.bloquearPagina(false);
      }

      // --- Carrito (Shrine) ---
      cajon() {
        return document.querySelector('cart-drawer');
      }

      // 17-10: con Kaching Cart activo, el carrito que se abre es el de Kaching (kachingCartApi.openCart).
      kaching() {
        return window.kachingCartApi && typeof window.kachingCartApi.openCart === 'function' ? window.kachingCartApi : null;
      }

      async agregar(form) {
        const boton = form.querySelector('.vc-form__boton');
        const error = form.querySelector('.vc-form__error');
        if (!boton || boton.disabled || boton.classList.contains('is-cargando')) return;
        const id = Number(new FormData(form).get('id'));
        if (!id) return;
        boton.classList.add('is-cargando');
        boton.setAttribute('aria-busy', 'true');
        if (error) {
          error.hidden = true;
          error.textContent = '';
        }
        const kc = this.kaching();
        const cajon = kc ? null : this.cajon();
        const cuerpo = { items: [{ id, quantity: 1 }] };
        if (cajon && typeof cajon.renderContents === 'function') {
          const secciones =
            typeof cajon.getSectionsToRender === 'function'
              ? cajon.getSectionsToRender().map((s) => s.id)
              : ['cart-drawer', 'cart-icon-bubble'];
          cuerpo.sections = secciones;
          cuerpo.sections_url = window.location.pathname;
        }
        try {
          const r = await fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(cuerpo),
          });
          const datos = await r.json().catch(() => ({}));
          if (!r.ok) throw new Error(datos.description || datos.message || 'No pudimos agregarlo. Intenta de nuevo.');
          if (this.modal && this.modal.open) this.cerrar();
          if (kc) {
            kc.openCart();
          } else if (cajon && typeof cajon.renderContents === 'function' && datos.sections) {
            cajon.classList.remove('is-empty');
            cajon.renderContents(datos); // abre el carrito lateral con lo recién agregado
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (err) {
          if (error) {
            error.textContent = err.message;
            error.hidden = false;
          }
        } finally {
          boton.classList.remove('is-cargando');
          boton.removeAttribute('aria-busy');
        }
      }

      // Bloquea el scroll de la página mientras la vista grande está abierta
      bloquearPagina(si) {
        document.documentElement.classList.toggle('vc-bloqueo', !!si);
      }

      // --- Videos del carrusel ---
      cargar(video) {
        this.ponerPoster(video);
        if (video.dataset.cargado) return;
        video.dataset.cargado = '1';
        video.src = video.dataset.src;
        video.preload = 'metadata';
      }

      // Velocidad (12-10): el póster llega en data-poster y se pone a pantalla y media de distancia
      // (antes los 5 pósters bajaban al abrir la portada, ~230 KB, aunque la sección está muy abajo).
      ponerPoster(v) {
        if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster);
      }

      observarVideos() {
        const videos = this.querySelectorAll('video.vc__video');
        if (!('IntersectionObserver' in window)) {
          videos.forEach((v) => { this.ponerPoster(v); this.cargar(v); });
          return;
        }
        // Todos los pósters a la vez cuando la sección se acerca (si se observa cada video, los que están fuera
        // del carrusel quedan vacíos al deslizar)
        this.ioPoster = new IntersectionObserver(
          (entradas) => entradas.forEach((e) => {
            if (!e.isIntersecting) return;
            videos.forEach((v) => this.ponerPoster(v));
            this.ioPoster.disconnect();
          }),
          { rootMargin: '150% 0px' }
        );
        const lista = videos[0] && videos[0].closest('.vc__item') ? videos[0].closest('.vc__item').parentElement : this;
        this.ioPoster.observe(lista);
        // 1) Precarga solo los datos iniciales cuando el video se acerca a la pantalla
        this.ioCarga = new IntersectionObserver(
          (entradas) => entradas.forEach((e) => e.isIntersecting && this.cargar(e.target)),
          { rootMargin: '200px 300px' }
        );
        videos.forEach((v) => this.ioCarga.observe(v));
        if (!this.auto) return;
        // 2) Reproduce sin sonido solo mientras se ve al menos el 60 % (sin margen)
        this.io = new IntersectionObserver(
          (entradas) => {
            entradas.forEach((e) => {
              const v = e.target;
              const item = v.closest('.vc__item');
              if (e.isIntersecting && e.intersectionRatio >= 0.6) {
                this.cargar(v);
                const p = v.play();
                if (p && p.catch) p.catch(() => {});
                item.classList.add('is-reproduciendo');
              } else {
                v.pause();
                item.classList.remove('is-reproduciendo');
              }
            });
          },
          { threshold: [0, 0.6] }
        );
        videos.forEach((v) => this.io.observe(v));
      }

      alternarSonido(boton) {
        const video = boton.closest('.vc__medio').querySelector('video');
        if (!video) return;
        this.cargar(video);
        const activar = video.muted;
        this.querySelectorAll('video.vc__video').forEach((v) => {
          v.muted = true;
        });
        this.querySelectorAll('.vc__sonido').forEach((b) => {
          b.setAttribute('aria-pressed', 'false');
          b.setAttribute('aria-label', 'Activar sonido');
        });
        if (activar) {
          video.muted = false;
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
          video.closest('.vc__item').classList.add('is-reproduciendo');
          boton.setAttribute('aria-pressed', 'true');
          boton.setAttribute('aria-label', 'Silenciar');
        }
      }

      prepararFlechas() {
        const prev = this.querySelector('.vc__flecha--prev');
        const next = this.querySelector('.vc__flecha--next');
        if (!prev || !next) return;
        const actualizar = () => {
          const max = this.pista.scrollWidth - this.pista.clientWidth;
          prev.hidden = this.pista.scrollLeft <= 4;
          next.hidden = this.pista.scrollLeft >= max - 4;
        };
        [prev, next].forEach((b) =>
          b.addEventListener('click', () => {
            const item = this.items[0];
            const paso = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.pista).columnGap || 0) : 300;
            const visibles = Math.max(1, Math.floor(this.pista.clientWidth / paso) - 1);
            this.pista.scrollBy({ left: Number(b.dataset.dir) * paso * visibles, behavior: 'smooth' });
          })
        );
        this.pista.addEventListener('scroll', () => requestAnimationFrame(actualizar), { passive: true });
        this.alRedimensionar = actualizar;
        window.addEventListener('resize', actualizar);
        actualizar();
      }

      // Selector de variante: actualiza precio y nombre en la tarjeta (o en la vista grande)
      prepararVariantes(raiz) {
        raiz.querySelectorAll('.vc-form__select').forEach((sel) => {
          if (sel.dataset.listo) return;
          sel.dataset.listo = '1';
          const actualizar = () => {
            const op = sel.options[sel.selectedIndex];
            const cont = sel.closest('.vc__tarjeta') || sel.closest('.vc-modal__producto');
            if (!cont || !op) return;
            cont.querySelectorAll('[data-precio]').forEach((el) => (el.textContent = op.dataset.precioVariante));
            cont.querySelectorAll('[data-antes]').forEach((el) => {
              el.textContent = op.dataset.antesVariante || '';
              el.hidden = !op.dataset.antesVariante;
            });
            cont.querySelectorAll('[data-variante]').forEach((el) => (el.textContent = (el.dataset.prefijo || '') + op.textContent.trim()));
          };
          sel.addEventListener('change', actualizar);
        });
      }

      // --- Vista grande ---
      prepararModal() {
        this.mVideo = this.modal.querySelector('.vc-modal__video');
        // Botón de sonido de la vista grande (sincronizado con los controles del video)
        this.mSonido = this.modal.querySelector('.vc-modal__sonido');
        if (this.mSonido) {
          const pintarSonido = (this.pintarSonido = () => {
            const suena = !this.mVideo.muted && this.mVideo.volume > 0;
            this.mSonido.setAttribute('aria-pressed', suena ? 'true' : 'false');
            this.mSonido.setAttribute('aria-label', suena ? 'Silenciar' : 'Activar sonido');
          });
          this.mSonido.addEventListener('click', (e) => {
            e.stopPropagation();
            this.mVideo.muted = !this.mVideo.muted;
            this.silenciado = this.mVideo.muted;
            if (!this.mVideo.muted && this.mVideo.volume === 0) this.mVideo.volume = 1;
            if (!this.mVideo.muted && this.mVideo.paused) this.mVideo.play().catch(() => {});
            pintarSonido();
          });
          this.mVideo.addEventListener('volumechange', pintarSonido);
          pintarSonido();
        }
        this.mProducto = this.modal.querySelector('.vc-modal__producto');
        this.mPrev = this.modal.querySelector('.vc-modal__nav--prev');
        this.mNext = this.modal.querySelector('.vc-modal__nav--next');
        this.modal.querySelector('.vc-modal__cerrar').addEventListener('click', () => this.cerrar());
        this.mPrev.addEventListener('click', () => this.mover(-1));
        this.mNext.addEventListener('click', () => this.mover(1));
        // Clic en el fondo oscuro (fuera de la caja) cierra
        this.modal.addEventListener('click', (e) => {
          if (e.target === this.modal) this.cerrar();
        });
        this.modal.addEventListener('cancel', (e) => {
          e.preventDefault();
          this.cerrar();
        });
        this.modal.addEventListener('keydown', (e) => {
          if (e.target.closest('select, input')) return;
          if (e.key === 'ArrowRight') this.mover(1);
          if (e.key === 'ArrowLeft') this.mover(-1);
        });
        let x0 = null;
        const medio = this.modal.querySelector('.vc-modal__medio');
        medio.addEventListener('touchstart', (e) => (x0 = e.touches[0].clientX), { passive: true });
        medio.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const dx = e.changedTouches[0].clientX - x0;
          x0 = null;
          if (Math.abs(dx) > 50) this.mover(dx < 0 ? 1 : -1);
        });
      }

      conVideo() {
        return this.items.filter((it) => it.querySelector('[data-abrir]'));
      }

      abrir(indice) {
        const lista = this.conVideo();
        const item = this.items[indice];
        if (!item) return;
        this.actual = lista.indexOf(item);
        this.volverA = document.activeElement;
        this.items.forEach((it) => {
          const v = it.querySelector('video.vc__video');
          if (v) v.pause();
        });
        // Cada vez que se abre la vista parte con sonido; mientras esté abierta, se recuerda si la persona silenció
        if (!this.modal.open) this.silenciado = false;
        this.mostrar(item);
        if (!this.modal.open) {
          this.modal.showModal();
          this.bloquearPagina(true);
        }
      }

      mostrar(item) {
        const lista = this.conVideo();
        const v = item.querySelector('video.vc__video');
        this.mVideo.muted = !!this.silenciado;
        this.mVideo.poster = v.getAttribute('poster') || v.dataset.poster || '';
        this.mVideo.src = v.dataset.src;
        this.mVideo.setAttribute('aria-label', v.getAttribute('aria-label') || '');
        const p = this.mVideo.play();
        if (p && p.catch) p.catch(() => {});
        const tpl = item.querySelector('template.vc__datos');
        this.mProducto.innerHTML = '';
        if (tpl) {
          const contenido = tpl.content.cloneNode(true);
          const wrap = contenido.querySelector('.vc-modal__producto-wrap');
          if (wrap && wrap.children.length) this.mProducto.append(...wrap.childNodes);
          this.prepararVariantes(this.mProducto);
        }
        this.mPrev.disabled = this.actual <= 0;
        this.mNext.disabled = this.actual >= lista.length - 1;
        if (this.pintarSonido) this.pintarSonido();
      }

      mover(dir) {
        const lista = this.conVideo();
        const nuevo = this.actual + dir;
        if (nuevo < 0 || nuevo >= lista.length) return;
        this.actual = nuevo;
        this.mostrar(lista[nuevo]);
        lista[nuevo].scrollIntoView({ block: 'nearest', inline: 'center' });
      }

      cerrar() {
        if (!this.modal.open) return;
        this.mVideo.pause();
        this.mVideo.removeAttribute('src');
        this.mVideo.load();
        this.mProducto.innerHTML = '';
        this.modal.close();
        this.bloquearPagina(false);
        if (this.volverA && this.volverA.focus) this.volverA.focus({ preventScroll: true });
        // Retoma la reproducción de los videos visibles
        if (this.auto && this.io) {
          this.querySelectorAll('video.vc__video').forEach((v) => {
            this.io.unobserve(v);
            this.io.observe(v);
          });
        }
      }
    }
  );
}
